module.exports = "../../static/img/user.0ed41ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iconActive/user.png
// module id = D3bw
// module chunks = 9